import HWH5 from '@/utils/hwh5-cloudonline'
import Platform from "./platform"
import http from "@/utils/http";
import {getQuery, locationTo, baseURL, complete} from "@/utils/url"
import {initDebug} from "@/utils/commons"

class PlatformWelink extends Platform {
    signatureCheckSuccess = false
    requestAuthCodeSuccess = false
    constructor(params) {
        super(params);
        this._setAgentId(getQuery('agentId'))
        this.signatureCheckSuccess = sessionStorage.getItem('welink.checkSignature.onsuccess') === 'true'
        this.requestAuthCodeSuccess = sessionStorage.getItem('welink.requestAuthCode.onsuccess') === 'true'
    }

    init() {
        let self = this;
        initDebug();
        return new Promise((resolve, reject) => {
            // 避免页面之间跳转时重复登录
            if (this.requestAuthCodeSuccess) {
                resolve();
                return;
            }
            if (self.signatureCheckSuccess) {
                self._initAuth(resolve, reject)
            } else {
                self.config().then(() => {
                    console.log("config:success")
                    self._initAuth(resolve, reject)
                }).catch(reject);
            }
        })
    }

    config() {
        let self = this;
        return new Promise((resolve, reject) => {
            console.log("getConfig")

            http.post('/welink/jsapi/getConfig.htm', {
                url: window.location.href.split('#')[0],
                agentId: (self.agentId || '')
            }).then(resp => {
                console.log("resp:", "resp")
                if (resp.data) {
                    let jsApiList = ['uploadImage', 'getLocation', 'startLocationUpdate',
                        'stopLocationUpdate', 'setStorage', 'getStorage', 'clearStorage',
                        'removeStorage', 'chooseImage', 'recordAudio', 'playMedia', 'playAudio',
                        'selectContacts', 'openUserProfile', 'createIMGroupChat', 'openIMChat', 'writeMail', 'share'];
                    let configObj = {
                        appId: self.agentId, // 应用的client_id
                        timestamp: resp.data.timestamp, // 与生成签名一致的时间戳，精确到秒十位
                        noncestr: resp.data.nonceStr, // 服务端使用的随机串
                        signature: resp.data.signature, // 签名信息
                        jsApiList: jsApiList,
                        url: resp.data.url
                    };
                    console.log("configObj:", configObj)
                    HWH5.config(configObj);
                    HWH5.ready(function () {
                        console.log("ready:")
                        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                        self.signatureCheckSuccess = true;
                        sessionStorage.setItem('welink.checkSignature.onsuccess', 'true');
                        resolve();
                    });
                    HWH5.error(function (err) {
                        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                        if (err) {
                            console.log("签名失败:" + err.msg);
                        } else {
                            console.log("签名失败");
                        }
                        reject(err);
                    });
                    // self.signatureCheckSuccess = true;
                    // resolve();
                }

            }).catch(err => {
                console.log(err)
                reject(err)
            });
        })
    }

    close() {
        console.log('close');
        HWH5.close().catch(error => {
            console.log('关闭webview异常', error);
        });
    }

    hideOptionMenu() {
        console.log('welink不支持')
    }

    setTitle(title) {
        console.log('setTitle')
        HWH5.setNavigationBarTitle({title: title}).catch(error => {
            console.log('设置标题异常', error, title);
        });
    }

    _setAgentId(agentId) {
        this.agentId = agentId
        sessionStorage.setItem('agentId', this.agentId)
    }

    /**
     * 第一步: getAuthCode()获取免登授权码code
     * @param resolve
     * @param reject
     * @private
     */
    //自动登录
    async _initAuth(resolve, reject) {
        let self = this;
        console.log("_initAuth:1")
        var key = 'welink.requestAuthCode.onsuccess';

        // 避免页面之间跳转时重复登录
        if (this.requestAuthCodeSuccess) {
            resolve();
            return;
        }
        console.log("_initAuth:2")
        try {
            const auth = await HWH5.getAuthCode()
            console.log("auth:", auth)
            let params = {
                code: auth.code,
                agentId: self.agentId || ''
            };
            const resp = await http.post("/welink/channel/auth.htm", params)
            console.log("resp:",resp)
            const {code} = resp || {}
            if (code == 1050504) {
                window.location.href = complete("extensionapp/index.html#/identification");
                reject(resp);
                return;
            }
            sessionStorage.setItem(key, 'true');
            resolve();
        } catch (err) {
            console.log("unified-catch:", err)
            reject(err)
        }

    }
}

export default PlatformWelink
